import { useCallback } from 'react';
import { StreamType } from '@smart-tv/typings/content';

import {
  retrievePersistentData,
  storePersistentData
} from '@smart-tv/utils/persistent-data/persistent-data';
import { FeatureIntroLocation } from '@smart-tv/typings/content';

export const SEEN_FEATURE_INTROS_KEY = 'seen-feature-intros';

export const useFeatureIntros = () => {
  const mapStreamTypeToFeatureIntroLocation = useCallback((streamType: string) => {
    switch (streamType) {
      case StreamType.LiveStream:
        return FeatureIntroLocation.LIVE_PLAYER;
      case StreamType.StartOver:
        return FeatureIntroLocation.SFF_PLAYER;
      case StreamType.Vod:
      case StreamType.CatchUp:
        return FeatureIntroLocation.VOD_PLAYER;
      default:
        return FeatureIntroLocation.PLAYER;
    }
  }, []);

  const getSeenFeatureIntroIds = useCallback(
    (): string[] => retrievePersistentData<string[]>(SEEN_FEATURE_INTROS_KEY) || [],
    []
  );

  const markFeatureIntroAsSeen = useCallback(
    (id: string) => {
      const seenFeatureIntroIds = getSeenFeatureIntroIds();
      if (!seenFeatureIntroIds.includes(id)) {
        storePersistentData(SEEN_FEATURE_INTROS_KEY, [...seenFeatureIntroIds, id]);
      }
    },
    [getSeenFeatureIntroIds]
  );

  const resetSeenFeatureIntros = useCallback(() => {
    storePersistentData(SEEN_FEATURE_INTROS_KEY, []);
  }, []);

  return {
    getSeenFeatureIntroIds,
    markFeatureIntroAsSeen,
    resetSeenFeatureIntros,
    mapStreamTypeToFeatureIntroLocation
  };
};

export default useFeatureIntros;
